import AvataUpload from "components/AvataUpload";
import {
  Button,
  Col,
  DatePicker,
  Form,
  FormInstance,
  Input,
  Row,
  Select,
  Typography,
} from "antd";
import React, { FC, useEffect } from "react";
import styled from "@emotion/styled";
import locale from "antd/es/date-picker/locale/th_TH";
import TextArea from "antd/es/input/TextArea";
import { useTestMessagingLine } from "hooks/useLine";
import { testMessagingLine } from "services/lineApi";
import { DataTokenLine } from "services/interface";
// import SettingAvatar from "./SettingAvatar";

interface SettingLineAlertFormProps {
  form: FormInstance;
  onFinish: (values: any) => void;
  data: DataTokenLine | undefined;
//   avatar: any;
}

const SettingLineAlertForm: FC<SettingLineAlertFormProps> = ({
  form,
  onFinish,
  data,
//   avatar,
}) => {


  const handleTestMessaging = () => {
    testMessagingLine();
  };

  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 24 }}
      >
        {/* <Row style={{ marginBottom: 20 }}>
          <Typography.Text>วิธีการขอรับ Line Token</Typography.Text>
        </Row> */}
        <Form.Item
          name="token"
          labelAlign="left"
          label="Line Token"
          rules={[{ required: true, message: "กรุณากรอก line token" }]}
        >
            <TextArea rows={4} placeholder="Line Token"  /> 
        </Form.Item>
       
        <Form.Item>
          <WrapperButton>     
                   
            <Button
              style={{ width: 250, marginRight:"10px" }}
              className="product-btn"
              size="large"
              onClick={handleTestMessaging}
              disabled={!data} 
            >
              ส่งข้อความทดสอบ
            </Button>
            <Button
              style={{ width: 250, marginRight:"10px"}}
              type="primary"
              size="large"
              htmlType="submit"
            >
              บันทึก
            </Button>
          </WrapperButton>
        </Form.Item>
      </Form>
    </>
  );
};

export default SettingLineAlertForm;

const WrapperAvata = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
  width: 130px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
`;

const WrapperButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
`;
